/* eslint-disable react-hooks/rules-of-hooks */
import { EntryGuard, Step, useScope } from 'ia-react-core';
import React, { useMemo } from 'react';
import MfaPasswordStep from './MfaPasswordStep';
import Constants from '../../../../Constants';
import { MfaOnboardingResourceInfo } from '../../../../components/MfaOnboardingResource';
import { MfaOnboarding } from '../../../../interfaces/MfaOnboarding';
import AuthenticationFactorsResource from '../../../../components/AuthenticationFactorsResource';

const getMfaPasswordStep = () => {
  const { getScopedState } = useScope();

  const entryGuards = useMemo<EntryGuard[]>(() => [
    ({ redirect }) => {
      const mfaOnboarding: MfaOnboarding = getScopedState(MfaOnboardingResourceInfo.dataDst);

      if (mfaOnboarding?.data?.onboardingStatus !== 'completed') {
        return redirect(Constants.MfaInformationsStepSegment);
      }

      return undefined;
    },
  ], [getScopedState]);

  return (
    <Step
      name="password"
      path={Constants.MfaPasswordStepSegment}
      entryGuards={entryGuards}
    >
      <AuthenticationFactorsResource autoRequest requestOnLanguageChange />
      <MfaPasswordStep />
    </Step>
  );
};

export default getMfaPasswordStep;
